import {
  Box,
  Card,
  Container,
  Grid,
  Modal,
  TextField,
  Typography
} from '@mui/material';
import ReactApexChart from 'react-apexcharts';
import React, { useContext, useEffect, useState } from 'react';
import { I_S3Credentials } from 'src/interfaces/S3Types';
import { getChartOptions } from './chartOptions';
import {
  chartAggregatedDataInterface,
  overviewInterface,
  transformInputToAggregatedDataJson
} from 'src/interfaces/Chart';
import Button from '@mui/material/Button';
import { FormattedMessage } from 'react-intl';
import CircularProgress from '@mui/material/CircularProgress';
import { DateTimePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs, { Dayjs } from 'dayjs';
import { UserContext } from '../../../contexts/userContext';
import { UserType } from '../../../interfaces/UserTypes';

interface salidomoOverviewProps {
  s3Credentials: I_S3Credentials;
  id: number;
  connected?: boolean;
  loading?: boolean;
}

const computeLast7Days = (): string[] => {
  const currentDate = new Date();
  const daysOfWeek = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  let currentDayIndex = currentDate.getDay();
  const last7Days = [];

  for (let i = 0; i < 7; i++) {
    last7Days.push(daysOfWeek[currentDayIndex]);
    currentDayIndex++;
    if (currentDayIndex > 6) {
      currentDayIndex = 0;
    }
  }
  return last7Days;
};
//
// function SalidomoOverview(props: salidomoOverviewProps) {
//   const context = useContext(UserContext);
//   const { currentUser } = context;
//   const [loading, setLoading] = useState(true);
//   const [aggregatedChartState, setAggregatedChartState] = useState(0);
//   const [isDateModalOpen, setIsDateModalOpen] = useState(false);
//   const [isErrorDateModalOpen, setErrorDateModalOpen] = useState(false);
//   const [dateSelectionError, setDateSelectionError] = useState('');
//   const [dateOpen, setDateOpen] = useState(false);
//
//   const [aggregatedDataArray, setAggregatedDataArray] = useState<
//     {
//       chartData: chartAggregatedDataInterface;
//       chartOverview: overviewInterface;
//       datelist: any[];
//       netbalance: any[];
//     }[]
//   >([]);
//
//   const [startDate, setStartDate] = useState(dayjs().add(-1, 'day'));
//   const [endDate, setEndDate] = useState(dayjs());
//
//   useEffect(() => {
//     handleWeekData();
//   }, []);
//
//   const handleWeekData = () => {
//     setAggregatedChartState(0);
//
//     if (
//       aggregatedDataArray[aggregatedChartState] &&
//       aggregatedDataArray[aggregatedChartState].chartData != null
//     ) {
//       return;
//     }
//     setLoading(true);
//
//     const resultPromise: Promise<{
//       chartAggregatedData: chartAggregatedDataInterface;
//       chartOverview: overviewInterface;
//       dateList: string[];
//     }> = transformInputToAggregatedData(
//       props.s3Credentials,
//       dayjs().subtract(1, 'week'),
//       dayjs()
//     );
//
//     resultPromise
//       .then((result) => {
//         const powerDifference = [];
//         for (
//           let i = 0;
//           i < result.chartAggregatedData.gridImportPower.data.length;
//           i++
//         ) {
//           powerDifference.push(
//             result.chartAggregatedData.gridImportPower.data[i] -
//               Math.abs(result.chartAggregatedData.gridExportPower.data[i])
//           );
//         }
//
//         setAggregatedDataArray((prevData) =>
//           prevData.concat({
//             chartData: result.chartAggregatedData,
//             chartOverview: result.chartOverview,
//             datelist: result.dateList,
//             netbalance: powerDifference
//           })
//         );
//
//         setAggregatedChartState(aggregatedDataArray.length);
//         setLoading(false);
//       })
//       .catch((error) => {
//         console.error('Error:', error);
//       });
//   };
//
//   const handleSetDate = () => {
//     setDateOpen(true);
//     setIsDateModalOpen(true);
//   };
//
//   const handleOkOnErrorDateModal = () => {
//     setErrorDateModalOpen(false);
//   };
//
//   const handleCancel = () => {
//     setIsDateModalOpen(false);
//     setDateOpen(false);
//   };
//
//   const handleConfirm = () => {
//     setIsDateModalOpen(false);
//     setDateOpen(false);
//
//     if (endDate.isAfter(dayjs())) {
//       setDateSelectionError('You cannot ask for future data');
//       setErrorDateModalOpen(true);
//       return;
//     } else if (startDate.isAfter(endDate)) {
//       setDateSelectionError('Εnd date must precede start date');
//       setErrorDateModalOpen(true);
//       return;
//     }
//     setLoading(true);
//
//     const resultPromise: Promise<{
//       chartAggregatedData: chartAggregatedDataInterface;
//       chartOverview: overviewInterface;
//       dateList: string[];
//     }> = transformInputToAggregatedData(
//       props.s3Credentials,
//       startDate,
//       endDate
//     );
//
//     resultPromise
//       .then((result) => {
//         const powerDifference = [];
//
//         for (
//           let i = 0;
//           i < result.chartAggregatedData.gridImportPower.data.length;
//           i++
//         ) {
//           powerDifference.push(
//             result.chartAggregatedData.gridImportPower.data[i] -
//               Math.abs(result.chartAggregatedData.gridExportPower.data[i])
//           );
//         }
//
//         setAggregatedDataArray((prevData) =>
//           prevData.concat({
//             chartData: result.chartAggregatedData,
//             chartOverview: result.chartOverview,
//             datelist: result.dateList,
//             netbalance: powerDifference
//           })
//         );
//
//         setAggregatedChartState(aggregatedDataArray.length);
//         setLoading(false);
//       })
//       .catch((error) => {
//         console.error('Error:', error);
//       });
//   };
//
//   const handleGoBack = () => {
//     if (aggregatedChartState > 0) {
//       setAggregatedChartState(aggregatedChartState - 1);
//     }
//   };
//
//   const handleGoForward = () => {
//     if (aggregatedChartState + 1 < aggregatedDataArray.length) {
//       setAggregatedChartState(aggregatedChartState + 1);
//     }
//   };
//
//   const renderGraphs = () => {
//     return (
//       <Container maxWidth="xl">
//         {isErrorDateModalOpen && (
//           <Modal open={isErrorDateModalOpen} onClose={() => {}}>
//             <Box
//               sx={{
//                 position: 'absolute',
//                 top: '50%',
//                 left: '50%',
//                 transform: 'translate(-50%, -50%)',
//                 width: 450,
//                 bgcolor: 'background.paper',
//                 borderRadius: 4,
//                 boxShadow: 24,
//                 p: 4,
//                 display: 'flex',
//                 flexDirection: 'column',
//                 alignItems: 'center'
//               }}
//             >
//               <Typography
//                 variant="body1"
//                 gutterBottom
//                 sx={{ fontWeight: 'bold' }}
//               >
//                 {dateSelectionError}
//               </Typography>
//
//               <Button
//                 sx={{
//                   marginTop: 2,
//                   textTransform: 'none',
//                   bgcolor: '#ffc04d',
//                   color: '#111111',
//                   '&:hover': { bgcolor: '#f7b34d' }
//                 }}
//                 onClick={handleOkOnErrorDateModal}
//               >
//                 Ok
//               </Button>
//             </Box>
//           </Modal>
//         )}
//
//         {isDateModalOpen && (
//           <LocalizationProvider dateAdapter={AdapterDayjs}>
//             <Modal open={isDateModalOpen} onClose={() => {}}>
//               <Box
//                 sx={{
//                   position: 'absolute',
//                   top: '50%',
//                   left: '50%',
//                   transform: 'translate(-50%, -50%)',
//                   width: 450,
//                   bgcolor: 'background.paper',
//                   borderRadius: 4,
//                   boxShadow: 24,
//                   p: 4,
//                   display: 'flex',
//                   flexDirection: 'column',
//                   alignItems: 'center'
//                 }}
//               >
//                 <DateTimePicker
//                   label="Select Start Date"
//                   value={startDate}
//                   onChange={(newDate: Dayjs | null) => {
//                     // Type assertion to Dayjs
//                     if (newDate) {
//                       setStartDate(newDate);
//                     }
//                   }}
//                   renderInput={(props) => <TextField {...props} />}
//                 />
//
//                 <DateTimePicker
//                   label="Select End Date"
//                   value={endDate}
//                   onChange={(newDate: Dayjs | null) => {
//                     // Type assertion to Dayjs
//                     if (newDate) {
//                       setEndDate(newDate);
//                     }
//                   }}
//                   renderInput={(props) => <TextField {...props} />}
//                 />
//
//                 <div
//                   style={{
//                     display: 'flex',
//                     alignItems: 'center',
//                     marginTop: 10
//                   }}
//                 >
//                   <Button
//                     sx={{
//                       marginTop: 2,
//                       textTransform: 'none',
//                       bgcolor: '#ffc04d',
//                       color: '#111111',
//                       '&:hover': { bgcolor: '#f7b34d' }
//                     }}
//                     onClick={handleConfirm}
//                   >
//                     Confirm
//                   </Button>
//
//                   <Button
//                     sx={{
//                       marginTop: 2,
//                       marginLeft: 2,
//                       textTransform: 'none',
//                       bgcolor: '#ffc04d',
//                       color: '#111111',
//                       '&:hover': { bgcolor: '#f7b34d' }
//                     }}
//                     onClick={handleCancel}
//                   >
//                     Cancel
//                   </Button>
//                 </div>
//               </Box>
//             </Modal>
//           </LocalizationProvider>
//         )}
//         <Grid container>
//           <Grid item xs={6} md={6}>
//             <Button
//               variant="contained"
//               onClick={handleSetDate}
//               disabled={loading}
//               sx={{
//                 marginTop: '20px',
//                 marginLeft: '10px',
//                 backgroundColor: dateOpen ? '#808080' : '#ffc04d',
//                 color: '#000000',
//                 '&:hover': { bgcolor: '#f7b34d' }
//               }}
//             >
//               <FormattedMessage id="set_date" defaultMessage="Set Date" />
//             </Button>
//           </Grid>
//
//           <Grid
//             container
//             justifyContent="flex-end"
//             alignItems="center"
//             item
//             xs={6}
//             md={6}
//           >
//             <Button
//               variant="contained"
//               disabled={!(aggregatedChartState > 0)}
//               onClick={handleGoBack}
//               sx={{
//                 marginTop: '20px',
//                 marginLeft: '10px',
//                 backgroundColor: '#ffc04d',
//                 color: '#000000',
//                 '&:hover': { bgcolor: '#f7b34d' }
//               }}
//             >
//               <FormattedMessage id="goback" defaultMessage="Zoom out" />
//             </Button>
//
//             <Button
//               variant="contained"
//               disabled={
//                 !(aggregatedChartState < aggregatedDataArray.length - 1)
//               }
//               onClick={handleGoForward}
//               sx={{
//                 marginTop: '20px',
//                 marginLeft: '10px',
//                 backgroundColor: '#ffc04d',
//                 color: '#000000',
//                 '&:hover': { bgcolor: '#f7b34d' }
//               }}
//             >
//               <FormattedMessage id="goback" defaultMessage="Zoom in" />
//             </Button>
//           </Grid>
//
//           {loading && (
//             <Container
//               maxWidth="xl"
//               sx={{
//                 display: 'flex',
//                 flexDirection: 'column',
//                 justifyContent: 'center',
//                 alignItems: 'center',
//                 height: '100vh'
//               }}
//             >
//               <CircularProgress size={60} style={{ color: '#ffc04d' }} />
//               <Typography variant="body2" style={{ color: 'black' }} mt={2}>
//                 <FormattedMessage id="fetchingData" defaultMessage="Fetching data..." />
//               </Typography>
//             </Container>
//           )}
//
//           {!loading && (
//             <Grid item xs={12} md={12}>
//               <Grid
//                 container
//                 direction="row"
//                 justifyContent="center"
//                 alignItems="stretch"
//                 spacing={3}
//               >
//                 <Grid item md={6} xs={12}>
//                   <Card
//                     sx={{
//                       overflow: 'visible',
//                       marginTop: '30px',
//                       marginBottom: '30px'
//                     }}
//                   >
//                     <Box
//                       sx={{
//                         marginLeft: '20px'
//                       }}
//                     >
//                       <Box display="flex" alignItems="center">
//                         <Box>
//                           <Typography variant="subtitle1" noWrap>
//                             <FormattedMessage
//                               id="battery_soc"
//                               defaultMessage="Battery SOC (State Of Charge)"
//                             />
//                           </Typography>
//                         </Box>
//                       </Box>
//                       <Box
//                         sx={{
//                           display: 'flex',
//                           alignItems: 'center',
//                           justifyContent: 'flex-start',
//                           pt: 3
//                         }}
//                       ></Box>
//                     </Box>
//
//                     <ReactApexChart
//                       options={{
//                         ...getChartOptions(
//                           aggregatedDataArray[aggregatedChartState]
//                             .chartOverview.soc,
//                           'weekly',
//                           aggregatedDataArray[aggregatedChartState].datelist,
//                           true
//                         )
//                       }}
//                       series={[
//                         {
//                           ...aggregatedDataArray[aggregatedChartState].chartData
//                             .minsoc,
//                           color: '#69d2e7'
//                         },
//                         {
//                           ...aggregatedDataArray[aggregatedChartState].chartData
//                             .maxsoc,
//                           color: '#008FFB'
//                         }
//                       ]}
//                       type="bar"
//                       height={400}
//                     />
//                   </Card>
//                 </Grid>
//                 <Grid item md={6} xs={12}>
//                   <Card
//                     sx={{
//                       overflow: 'visible',
//                       marginTop: '30px',
//                       marginBottom: '30px'
//                     }}
//                   >
//                     <Box
//                       sx={{
//                         marginLeft: '20px'
//                       }}
//                     >
//                       <Box display="flex" alignItems="center">
//                         <Box>
//                           <Typography variant="subtitle1" noWrap>
//                             <FormattedMessage
//                               id="battery_power"
//                               defaultMessage={'Battery Energy'}
//                             />
//                           </Typography>
//                         </Box>
//                       </Box>
//                       <Box
//                         sx={{
//                           display: 'flex',
//                           alignItems: 'center',
//                           justifyContent: 'flex-start',
//                           pt: 3
//                         }}
//                       ></Box>
//                     </Box>
//
//                     {currentUser.userType == UserType.admin && (
//                       <ReactApexChart
//                         options={{
//                           ...getChartOptions(
//                             aggregatedDataArray[aggregatedChartState]
//                               .chartOverview.dcPower,
//                             'weekly',
//                             aggregatedDataArray[aggregatedChartState].datelist,
//                             false
//                           )
//                         }}
//                         series={[
//                           {
//                             ...aggregatedDataArray[aggregatedChartState]
//                               .chartData.dcChargingPower,
//                             color: '#008FFB'
//                           },
//                           {
//                             ...aggregatedDataArray[aggregatedChartState]
//                               .chartData.heatingPower,
//                             color: '#ff9900'
//                           },
//                           {
//                             ...aggregatedDataArray[aggregatedChartState]
//                               .chartData.dcDischargingPower,
//                             color: '#69d2e7'
//                           }
//                         ]}
//                         type="bar"
//                         height={400}
//                       />
//                     )}
//
//                     {currentUser.userType == UserType.client && (
//                       <ReactApexChart
//                         options={{
//                           ...getChartOptions(
//                             aggregatedDataArray[aggregatedChartState]
//                               .chartOverview.dcPowerWithoutHeating,
//                             'weekly',
//                             aggregatedDataArray[aggregatedChartState].datelist,
//                             true
//                           )
//                         }}
//                         series={[
//                           {
//                             ...aggregatedDataArray[aggregatedChartState]
//                               .chartData.dcChargingPower,
//                             color: '#008FFB'
//                           },
//
//                           {
//                             ...aggregatedDataArray[aggregatedChartState]
//                               .chartData.dcDischargingPower,
//                             color: '#69d2e7'
//                           }
//                         ]}
//                         type="bar"
//                         height={400}
//                       />
//                     )}
//                   </Card>
//                 </Grid>
//               </Grid>
//             </Grid>
//           )}
//         </Grid>
//       </Container>
//     );
//   };
//
//   return <>{renderGraphs()}</>;
// }

function SalidomoOverview(props: salidomoOverviewProps) {
  const context = useContext(UserContext);
  const { currentUser } = context;
  const [loading, setLoading] = useState(true);
  const [aggregatedChartState, setAggregatedChartState] = useState(0);
  const [isDateModalOpen, setIsDateModalOpen] = useState(false);
  const [isErrorDateModalOpen, setErrorDateModalOpen] = useState(false);
  const [dateSelectionError, setDateSelectionError] = useState('');
  const [dateOpen, setDateOpen] = useState(false);

  const [aggregatedDataArray, setAggregatedDataArray] = useState<
    {
      chartData: chartAggregatedDataInterface;
      chartOverview: overviewInterface;
      datelist: any[];
      netbalance: any[];
    }[]
  >([]);

  const [startDate, setStartDate] = useState(dayjs().add(-1, 'day'));
  const [endDate, setEndDate] = useState(dayjs());

  useEffect(() => {
    handleWeekData();
  }, []);

  const handleWeekData = () => {
    setAggregatedChartState(0);

    if (
      aggregatedDataArray[aggregatedChartState] &&
      aggregatedDataArray[aggregatedChartState].chartData != null
    ) {
      return;
    }
    setLoading(true);

    const resultPromise: Promise<{
      chartAggregatedData: chartAggregatedDataInterface;
      chartOverview: overviewInterface;
      dateList: string[];
    }> = transformInputToAggregatedDataJson(
      props.s3Credentials,
      dayjs().subtract(1, 'week'),
      dayjs()
    );

    resultPromise
      .then((result) => {
        const powerDifference = [];
        for (
          let i = 0;
          i < result.chartAggregatedData.gridImportPower.data.length;
          i++
        ) {
          powerDifference.push(
            result.chartAggregatedData.gridImportPower.data[i] -
              Math.abs(result.chartAggregatedData.gridExportPower.data[i])
          );
        }

        setAggregatedDataArray((prevData) =>
          prevData.concat({
            chartData: result.chartAggregatedData,
            chartOverview: result.chartOverview,
            datelist: result.dateList,
            netbalance: powerDifference
          })
        );

        setAggregatedChartState(aggregatedDataArray.length);
        setLoading(false);
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  };

  const handleSetDate = () => {
    setDateOpen(true);
    setIsDateModalOpen(true);
  };

  const handleOkOnErrorDateModal = () => {
    setErrorDateModalOpen(false);
  };

  const handleCancel = () => {
    setIsDateModalOpen(false);
    setDateOpen(false);
  };

  const handleConfirm = () => {
    setIsDateModalOpen(false);
    setDateOpen(false);

    if (endDate.isAfter(dayjs())) {
      setDateSelectionError('You cannot ask for future data');
      setErrorDateModalOpen(true);
      return;
    } else if (startDate.isAfter(endDate)) {
      setDateSelectionError('Εnd date must precede start date');
      setErrorDateModalOpen(true);
      return;
    }
    setLoading(true);

    const resultPromise: Promise<{
      chartAggregatedData: chartAggregatedDataInterface;
      chartOverview: overviewInterface;
      dateList: string[];
    }> = transformInputToAggregatedDataJson(
      props.s3Credentials,
      startDate,
      endDate
    );

    resultPromise
      .then((result) => {
        const powerDifference = [];

        for (
          let i = 0;
          i < result.chartAggregatedData.gridImportPower.data.length;
          i++
        ) {
          powerDifference.push(
            result.chartAggregatedData.gridImportPower.data[i] -
              Math.abs(result.chartAggregatedData.gridExportPower.data[i])
          );
        }

        setAggregatedDataArray((prevData) =>
          prevData.concat({
            chartData: result.chartAggregatedData,
            chartOverview: result.chartOverview,
            datelist: result.dateList,
            netbalance: powerDifference
          })
        );

        setAggregatedChartState(aggregatedDataArray.length);
        setLoading(false);
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  };

  const handleGoBack = () => {
    if (aggregatedChartState > 0) {
      setAggregatedChartState(aggregatedChartState - 1);
    }
  };

  const handleGoForward = () => {
    if (aggregatedChartState + 1 < aggregatedDataArray.length) {
      setAggregatedChartState(aggregatedChartState + 1);
    }
  };

  const renderGraphs = () => {
    return (
      <Container maxWidth="xl">
        {!props.connected && !props.loading && (
          <Typography
            variant="body2"
            sx={{
              color: 'red',
              fontWeight: 'bold',
              textAlign: 'center',
              marginTop: '10px',
              marginBottom: '10px'
            }}
          >
            <FormattedMessage
              id="installationOffline"
              defaultMessage="Installation is currently offline. Showing last available data."
            />
          </Typography>
        )}
        {isErrorDateModalOpen && (
          <Modal open={isErrorDateModalOpen} onClose={() => {}}>
            <Box
              sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: { xs: '90vw', sm: 450 },
                bgcolor: 'background.paper',
                borderRadius: 4,
                boxShadow: 24,
                p: 4,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center'
              }}
            >
              <Typography
                variant="body1"
                gutterBottom
                sx={{ fontWeight: 'bold' }}
              >
                {dateSelectionError}
              </Typography>

              <Button
                sx={{
                  marginTop: 2,
                  textTransform: 'none',
                  bgcolor: '#ffc04d',
                  color: '#111111',
                  '&:hover': { bgcolor: '#f7b34d' }
                }}
                onClick={handleOkOnErrorDateModal}
              >
                Ok
              </Button>
            </Box>
          </Modal>
        )}

        {isDateModalOpen && (
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Modal open={isDateModalOpen} onClose={() => {}}>
              <Box
                sx={{
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                  width: { xs: '90vw', sm: 450 },
                  bgcolor: 'background.paper',
                  borderRadius: 4,
                  boxShadow: 24,
                  p: 4,
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center'
                }}
              >
                <DateTimePicker
                  label="Select Start Date"
                  value={startDate}
                  onChange={(newDate: Dayjs | null) => {
                    // Type assertion to Dayjs
                    if (newDate) {
                      setStartDate(newDate);
                    }
                  }}
                  renderInput={(props) => <TextField {...props} />}
                />

                <DateTimePicker
                  label="Select End Date"
                  value={endDate}
                  onChange={(newDate: Dayjs | null) => {
                    // Type assertion to Dayjs
                    if (newDate) {
                      setEndDate(newDate);
                    }
                  }}
                  renderInput={(props) => <TextField {...props} />}
                />

                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    marginTop: 10
                  }}
                >
                  <Button
                    sx={{
                      marginTop: 2,
                      textTransform: 'none',
                      bgcolor: '#ffc04d',
                      color: '#111111',
                      '&:hover': { bgcolor: '#f7b34d' }
                    }}
                    onClick={handleConfirm}
                  >
                    Confirm
                  </Button>

                  <Button
                    sx={{
                      marginTop: 2,
                      marginLeft: 2,
                      textTransform: 'none',
                      bgcolor: '#ffc04d',
                      color: '#111111',
                      '&:hover': { bgcolor: '#f7b34d' }
                    }}
                    onClick={handleCancel}
                  >
                    Cancel
                  </Button>
                </div>
              </Box>
            </Modal>
          </LocalizationProvider>
        )}
        <Grid container>
          {!props.loading && (props.connected !== false || aggregatedDataArray.length > 0) && (<>
          <Grid item xs={6} md={6}>
            <Button
              variant="contained"
              onClick={handleSetDate}
              disabled={loading}
              sx={{
                marginTop: '20px',
                marginLeft: '10px',
                backgroundColor: dateOpen ? '#808080' : '#ffc04d',
                color: '#000000',
                '&:hover': { bgcolor: '#f7b34d' }
              }}
            >
              <FormattedMessage id="set_date" defaultMessage="Set Date" />
            </Button>
          </Grid>

          <Grid
            container
            justifyContent="flex-end"
            alignItems="center"
            item
            xs={6}
            md={6}
          >
            <Button
              variant="contained"
              disabled={!(aggregatedChartState > 0)}
              onClick={handleGoBack}
              sx={{
                marginTop: '20px',
                marginLeft: '10px',
                backgroundColor: '#ffc04d',
                color: '#000000',
                '&:hover': { bgcolor: '#f7b34d' }
              }}
            >
              <FormattedMessage id="goback" defaultMessage="Zoom out" />
            </Button>

            <Button
              variant="contained"
              disabled={
                !(aggregatedChartState < aggregatedDataArray.length - 1)
              }
              onClick={handleGoForward}
              sx={{
                marginTop: '20px',
                marginLeft: '10px',
                backgroundColor: '#ffc04d',
                color: '#000000',
                '&:hover': { bgcolor: '#f7b34d' }
              }}
            >
              <FormattedMessage id="goback" defaultMessage="Zoom in" />
            </Button>
          </Grid>
          </>)}

          {loading && (
            <Container
              maxWidth="xl"
              sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh'
              }}
            >
              <CircularProgress size={60} style={{ color: '#ffc04d' }} />
              <Typography variant="body2" style={{ color: 'black' }} mt={2}>
                <FormattedMessage id="fetchingData" defaultMessage="Fetching data..." />
              </Typography>
            </Container>
          )}

          {!loading && (
            <Grid item xs={12} md={12}>
              <Grid
                container
                direction="row"
                justifyContent="center"
                alignItems="stretch"
                spacing={3}
              >
                <Grid item md={6} xs={12}>
                  <Card
                    sx={{
                      overflow: 'visible',
                      marginTop: '30px',
                      marginBottom: '30px'
                    }}
                  >
                    <Box
                      sx={{
                        marginLeft: '20px'
                      }}
                    >
                      <Box display="flex" alignItems="center">
                        <Box>
                          <Typography variant="subtitle1" noWrap>
                            <FormattedMessage
                              id="battery_soc"
                              defaultMessage="Battery SOC (State Of Charge)"
                            />
                          </Typography>
                        </Box>
                      </Box>
                      <Box
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'flex-start',
                          pt: 3
                        }}
                      ></Box>
                    </Box>

                    <ReactApexChart
                      options={{
                        ...getChartOptions(
                          aggregatedDataArray[aggregatedChartState]
                            .chartOverview.soc,
                          'weekly',
                          aggregatedDataArray[aggregatedChartState].datelist,
                          true
                        )
                      }}
                      series={[
                        {
                          ...aggregatedDataArray[aggregatedChartState].chartData
                            .minsoc,
                          color: '#69d2e7'
                        },
                        {
                          ...aggregatedDataArray[aggregatedChartState].chartData
                            .maxsoc,
                          color: '#008FFB'
                        }
                      ]}
                      type="bar"
                      height={400}
                    />
                  </Card>
                </Grid>
                <Grid item md={6} xs={12}>
                  <Card
                    sx={{
                      overflow: 'visible',
                      marginTop: '30px',
                      marginBottom: '30px'
                    }}
                  >
                    <Box
                      sx={{
                        marginLeft: '20px'
                      }}
                    >
                      <Box display="flex" alignItems="center">
                        <Box>
                          <Typography variant="subtitle1" noWrap>
                            <FormattedMessage
                              id="battery_power"
                              defaultMessage={'Battery Energy'}
                            />
                          </Typography>
                        </Box>
                      </Box>
                      <Box
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'flex-start',
                          pt: 3
                        }}
                      ></Box>
                    </Box>

                    {currentUser.userType == UserType.admin && (
                      <ReactApexChart
                        options={{
                          ...getChartOptions(
                            aggregatedDataArray[aggregatedChartState]
                              .chartOverview.dcPower,
                            'weekly',
                            aggregatedDataArray[aggregatedChartState].datelist,
                            false
                          )
                        }}
                        series={[
                          {
                            ...aggregatedDataArray[aggregatedChartState]
                              .chartData.dcChargingPower,
                            color: '#008FFB'
                          },
                          {
                            ...aggregatedDataArray[aggregatedChartState]
                              .chartData.heatingPower,
                            color: '#ff9900'
                          },
                          {
                            ...aggregatedDataArray[aggregatedChartState]
                              .chartData.dcDischargingPower,
                            color: '#69d2e7'
                          }
                        ]}
                        type="bar"
                        height={400}
                      />
                    )}

                    {currentUser.userType == UserType.client && (
                      <ReactApexChart
                        options={{
                          ...getChartOptions(
                            aggregatedDataArray[aggregatedChartState]
                              .chartOverview.dcPowerWithoutHeating,
                            'weekly',
                            aggregatedDataArray[aggregatedChartState].datelist,
                            true
                          )
                        }}
                        series={[
                          {
                            ...aggregatedDataArray[aggregatedChartState]
                              .chartData.dcChargingPower,
                            color: '#008FFB'
                          },

                          {
                            ...aggregatedDataArray[aggregatedChartState]
                              .chartData.dcDischargingPower,
                            color: '#69d2e7'
                          }
                        ]}
                        type="bar"
                        height={400}
                      />
                    )}
                  </Card>
                </Grid>
              </Grid>
            </Grid>
          )}
        </Grid>
      </Container>
    );
  };

  if (props.loading) {
    return null;
  }

  return <>{renderGraphs()}</>;
}

export default SalidomoOverview;
